// Import the functions you need from the SDKs you need
import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

export const FIREBASE_CONFIG = {
  tenantId: import.meta.env.VITE_FIREBASE_TENANT_ID || 'archon-service-zi59g',
} as const

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCzy0heItRg4b4nQZKkOr7aKL0vp9uM_Ns',
  authDomain: 'enter-production.firebaseapp.com',
  projectId: 'enter-production',
  storageBucket: 'enter-production.firebasestorage.app',
  messagingSenderId: '964754225176',
  appId: '1:964754225176:web:2509dc776af9957ad7eb6d',
  measurementId: 'G-CZMD4YVJMT',
}

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(firebaseApp)

// Set the tenant ID for multi-tenancy
// This ensures all Firebase Auth operations are tenant-aware
auth.tenantId = FIREBASE_CONFIG.tenantId

// Initialize Firebase Analytics
export const analytics = getAnalytics(firebaseApp)

export default firebaseApp
